import api from "./api";
import { BrandType } from "../components/References/Brand/brandType";
export type DeleteBrand = {
  id: number | string;
};
 
/*Brand Select */
export const getBrandDropdown = async () => {
  return await api.get("/brands/dropdown");
};

/*Brand search & filter */
export const getBrandsApi = async (body: { limit: number; q: string; isActive?: boolean }) => {
  let url = `/brands?limit=${body.limit}&q=${body.q}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};


export const deleteBrand = async (dto: DeleteBrand) => {
  return await api.delete(`/brands/${dto.id}`);
};
export const getBrandById = async (brandId: string | undefined) => {
  return await api.get(`/brands/${brandId}`);
};

export const createBrand = async (brandDetails: BrandType) => {
  return await api.post("/brands", brandDetails);
};
export const editBrand = async (brandId: any, body: BrandType) => {
  return await api.put(`/brands/${brandId}`, body);
};
